<template>
  <div
    class="w-full h-full flex flex-col items-center group cursor-pointer select-none text-black-white"
  >
    <div class="relative transition-all duration-300 transform">
      <Icon :icon="item.icon" class="size-12" />
      <Icon
        v-if="!item.type?.includes('base')"
        :icon="item.connectIcon"
        class="w-4.5 h-4.5 absolute top-0 left-12"
      />
    </div>
    <div class="text-m-medium text-center">
      {{ item.name }}
    </div>
    <div v-if="!item.type?.includes('base')" class="mt-1 transition-all duration-300">
      <Battery :percentage="item.battery" :charging="charging" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'
  import Battery from '@/components/battery/index.vue'
  import { computed } from 'vue'
  import type { DeviceInterfaceType } from '@rapoo/device-sdk'

  interface Device {
    name: string
    img: string
    battery: number
    batteryStatus: number
    icon: string
    connectIcon: string
    type: DeviceInterfaceType
  }

  const charging = computed(() => props.item?.batteryStatus !== 1)

  const props = defineProps<{
    item: Device
    isActive: boolean
  }>()
</script>
